<template>

  <main class="glossary">

    <div class="glossary-inner">

      <h1 class="heading">Glossar</h1>

      <dl>
        <div
            class="glossary-group"
            v-for="index in Object.keys(definitions).sort()"
        >
          <div class="glossary-group-index">
            <h2 class="glossary-index">{{ index }}</h2>
          </div>
          <div class="glossary-group-items">
            <template v-for="definition in definitions[index]">
              <dt :id="definition['glossary_content_anchor_id']">
                <a :href="`#${definition['glossary_content_anchor_id']}`"
                   @click.prevent="handleAnchorClick(definition['glossary_content_anchor_id'])">
                  {{ definition['glossary_content_term'] }}
                </a>
              </dt>
              <dd v-html="definition['glossary_content_definition']"></dd>
            </template>
          </div>
        </div>
      </dl>
      <ReferenzComponent :referenzenList="referenceData.referenzen_list"/>
    </div>

  </main>

</template>

<script>

// console.log('Glossary');

import env from '../env';

import smoothReflow from '../../../node_modules/vue-smooth-reflow/dist/vue-smooth-reflow.min';

import wpApi from '../services/wpApi';

import ReferenzComponent from './ReferenzComponent.vue';

export default {
  mixins : [smoothReflow],
  created(){
    this.load();
    this.$root.states.glossaryIsShown = true;
  },
  destroyed(){
  },
  mounted(){
    // this.$smoothReflow({
    //   transition : 'height 800ms cubic-bezier(0.680, -0.550, 0.265, 1.550)',
    // });
    // Check if there's an ID in the URL
    // Get the hash, handling cases with or without the trailing slash
    this.checkAndScrollToAnchor();

    // Add the global click listener
    document.addEventListener('click', this.handleGlobalAnchorClick);
  },
  beforeDestroy() {
    // Clean up the event listener
    document.removeEventListener('click', this.handleGlobalAnchorClick);
  },
  components : {
    ReferenzComponent,
  },
  computed : {},
  data(){
    return {
      definitions : {},
      referenceData : {
        referenzen_list : [],
      },
    };
  },
  props : {
	  'definitions': {
		  default: () => [],
		  type: Array,
	  },
	  'referenceData': {
		  default: () => [],
		  type: Array,
	  }
  },
  metaInfo(){
    return {
      title : 'Glossar',
    };
  },
  watch : {
    // Watch the $route if using Vue Router or `definitions` if async data load
    definitions : {
      handler(){
        this.checkAndScrollToAnchor();
      },
      immediate : true,
    },
  },
  methods : {
    load(){
      // NO API CALLS - Component not used in WordPress-rendered mode
      console.warn('Glossary: load() - All data must come from PHP props, no API calls allowed');
      return;
      /* Legacy SPA code - not used
      wpApi.http.get(wpApi.host + wpApi.baseUrl + '/wp-json/acf/v3/pages/' + env.PAGE_ID_GLOSSAR)
          .then((response)=>{
            console.log('response', response);

            let definitions = {};
            response.data['acf']['glossary_repeater'].forEach((value)=>{
              const index = value['glossary_content_term'].substr(0, 1);
              if (definitions[index] === undefined) {
                definitions[index] = [];
              }
              definitions[index].push(value);
            });
            Object.keys(definitions).forEach((index)=>{
              definitions[index] = definitions[index].sort((a, b)=>{
                const aTerm = a['glossary_content_term'].toUpperCase();
                const bTerm = b['glossary_content_term'].toUpperCase();
                if (aTerm < bTerm) {
                  return -1;
                }
                if (aTerm > bTerm) {
                  return 1;
                }
                return 0;
              })
            });
            this.definitions = definitions;
            if (response.data.acf && response.data.acf.referenzen_list && response.data.acf.referenzen_list.length > 0) {
              this.referenceData.referenzen_list = response.data.acf.referenzen_list;
            }
            window.setTimeout(()=>{
              // this.$ga.page(this.$route.fullPath);
              if (window.dataLayer) {
                window.dataLayer.push({
                  event: 'Pageview',
                  url: this.$route.path.toLowerCase().replace(/\/$/, "")
                });
              }
            });
          })
          .catch((error)=>{
            console.log('error', error);
            // this.$router.push('/404');
          });
      */
    },
    handleAnchorClick(anchorId){
      // Update the URL hash without reloading the page
      window.history.pushState(null, null, `#${anchorId}`);
      // Smooth scroll to the element
      this.scrollToAnchor(anchorId);
    },
    scrollToAnchor(anchorId){
      this.$nextTick(()=>{
        const element = document.getElementById(anchorId);
        if (element) {
          const offset = 200; // Customize the gap here (in pixels)
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top : offsetPosition,
            behavior : "smooth",
          });
        }
      });
    },
    checkAndScrollToAnchor(){
      // Get the hash part from the URL
      const anchorId = window.location.hash.slice(1);
      if (anchorId) {
        // Check if element exists, retry if not found
        this.$nextTick(()=>{
          const element = document.getElementById(anchorId);
          if (element) {
            const offset = 200; // Customize the gap here (in pixels)
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
              top : offsetPosition,
              behavior : "smooth",
            });
          } else {
            // Retry scroll after a short delay if element is not yet rendered
            setTimeout(()=>this.scrollToAnchor(anchorId), 300);
          }
        });
      }
    },
    handleGlobalAnchorClick(event) {
      // Check if the clicked element is an anchor tag
      let target = event.target;

      // Traverse up the DOM tree to find the closest <a> tag
      while (target && target !== document) {
        if (target.tagName.toLowerCase() === 'a') {
          break;
        }
        target = target.parentNode;
      }

      if (target && target.tagName.toLowerCase() === 'a') {
        const href = target.getAttribute('href');

        // Check if href starts with '#'
        if (href && href.startsWith('#')) {
          const anchorId = href.slice(1);
          if (anchorId) {
            event.preventDefault(); // Prevent default jump

            // Use your custom handler
            this.handleAnchorClick(anchorId);
          }
        }
      }
    },
  },
}

</script>

<style lang="scss">

@import '../../css/variables';

html {
  scroll-behavior: smooth;
}

.glossary {
  overflow: hidden;
  will-change: height;
  .glossary-inner {
    padding: 5.5rem 1.5rem 3.5rem 1.5rem;
    @media screen and (min-width: 1200px) {
      padding: 5.5rem * $factor-1200 1.5rem * $factor-1200 3.5rem * $factor-1200 1.5rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      padding: 5.5rem * $factor-1440 1.5rem * $factor-1440 3.5rem * $factor-1440 1.5rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      padding: 5.5rem * $factor-1920 1.5rem * $factor-1920 3.5rem * $factor-1920 1.5rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      padding: 5.5rem * $factor-2400 1.5rem * $factor-2400 3.5rem * $factor-2400 1.5rem * $factor-2400;
    }
  }
  .glossary-group {
    display: flex;
    flex-direction: row;
    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
    .glossary-group-index {
      width: 53px;
      height: 64px;
      @media screen and (min-width: 768px) {
        width: 73px;
        height: 96px;
      }
      /*@media screen and (min-width: 1200px) {
          width: 7.5rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
          width: 7.5rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
          width: 7.5rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
          width: 7.5rem * $factor-2400;
      }*/
    }
    .glossary-group-items {
      width: 30rem;
      padding-top: 4.45rem;
      @media screen and (max-width: 767px) {
        width: 100%;
        padding-top: 0;
      }
      @media screen and (min-width: 1200px) {
        width: 30rem * $factor-1200;
        padding-top: 4.45rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
        width: 30rem * $factor-1440;
        padding-top: 4.45rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
        width: 30rem * $factor-1920;
        padding-top: 4.45rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
        width: 30rem * $factor-2400;
        padding-top: 4.45rem * $factor-2400;
      }
      dt {
        margin: 0 0 1rem 0;
        font-size: 12px;
        font-weight: bold;
        @media screen and (min-width: 768px) {
          font-size: 18px;
        }
        /*@media screen and (max-width: 767px) {
            margin: 0 0 1rem * $factor-720 0;
            font-size: 1rem * $factor-720;
        }
        @media screen and (min-width: 1200px) {
            margin: 0 0 1rem * $factor-1200 0;
            font-size: 1rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin: 0 0 1rem * $factor-1440 0;
            font-size: 1rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin: 0 0 1rem * $factor-1920 0;
            font-size: 1rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin: 0 0 1rem * $factor-2400 0;
            font-size: 1rem * $factor-2400;
        }*/
        a {
          color: $color-nochvielvor-black;
          &:hover {
            text-decoration: none;
          }
        }
      }
      dd {
        margin: 0 0 2rem 0;
        font-size: 12px;
        @media screen and (min-width: 768px) {
          font-size: 18px;
        }
        /*@media screen and (max-width: 767px) {
            margin: 0 0 2rem * $factor-720 0;
            font-size: 1rem * $factor-720;
        }
        @media screen and (min-width: 1200px) {
            margin: 0 0 2rem * $factor-1200 0;
            font-size: 1rem * $factor-1200;
        }
        @media screen and (min-width: 1440px) {
            margin: 0 0 2rem * $factor-1440 0;
            font-size: 1rem * $factor-1440;
        }
        @media screen and (min-width: 1920px) {
            margin: 0 0 2rem * $factor-1920 0;
            font-size: 1rem * $factor-1920;
        }
        @media screen and (min-width: 2400px) {
            margin: 0 0 2rem * $factor-2400 0;
            font-size: 1rem * $factor-2400;
        }*/
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .glossary-index {
      color: $color-nochvielvor-pink;
      font-size: 63px;
      font-weight: bold;
      line-height: 1;
      text-transform: uppercase;
      @media screen and (min-width: 768px) {
        font-size: 80px;
      }
      /*@media screen and (min-width: 1200px) {
          font-size: 6.25rem * $factor-1200;
      }
      @media screen and (min-width: 1440px) {
          font-size: 6.25rem * $factor-1440;
      }
      @media screen and (min-width: 1920px) {
          font-size: 6.25rem * $factor-1920;
      }
      @media screen and (min-width: 2400px) {
          font-size: 6.25rem * $factor-2400;
      }*/
    }
  }
  .heading {
    margin: 4rem 0;
    color: $color-nochvielvor-pink;
    font-size: 2.25rem;
    font-weight: bold;
    text-transform: uppercase;
    @media screen and (max-width: 767px) {
      margin: 0 0 4rem * $factor-720 0;
      font-size: 30px;
    }
    @media screen and (min-width: 1200px) {
      margin: 4rem * $factor-1200 0;
      //font-size: 2.25rem * $factor-1200;
    }
    @media screen and (min-width: 1440px) {
      margin: 4rem * $factor-1440 0;
      //font-size: 2.25rem * $factor-1440;
    }
    @media screen and (min-width: 1920px) {
      margin: 4rem * $factor-1920 0;
      //font-size: 2.25rem * $factor-1920;
    }
    @media screen and (min-width: 2400px) {
      margin: 4rem * $factor-2400 0;
      //font-size: 2.25rem * $factor-2400;
    }
  }
}

</style>
